enum PeoplePathnameSegmentType {
    Edit = 'edit',
    Note = 'note',
    People = 'people',
    Record = 'record',
    SearchOrAdd = 'search-or-add',
}

export default PeoplePathnameSegmentType;
